<template>
  <div>
    <v-container>
      <v-card>
        <v-img
          src="../finances_banner.png"
          class="white--text"
          gradient="to top, rgba(0,0,0,.1), rgba(0,0,0,.7)"
          max-height="250px"
        >
          <v-card-title class="text-h2 pa-10">
            Finances per Organization
          </v-card-title>
        </v-img>
      </v-card>
      <v-card outlined elevation="3" class="gmt-4">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                outlined
                :items="orgListing"
                item-value="orgID"
                item-text="orgName"
                label="Select the organization you want the summary for"
                v-model="selectedOrgID"
                @change="
                  fetchOrgStats({ anio: 2018 });
                  fetchBarChartData({ anio: 2018 });
                  updateAllData(defaultSelected);
                "
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <!-- IN TOTALS  -->
            <v-col cols="2" />
            <!-- <v-col class="d-flex justify-center"> -->
            <v-spacer />
            <v-col class="d-flex">
              <v-card width="300" class="pa-1 dark">
                <v-card-title class="text-uppercase text-h5 justify-center">
                  Taken
                </v-card-title>
                <v-card-text class="text-start text-h7">
                  <v-icon>mdi-cash-multiple </v-icon>
                  {{ totals["bought"]["price"] }} L
                  <br />
                  <v-icon>mdi-weight </v-icon>
                  {{ totals["bought"]["weight"] }} Kg
                  <br />
                  <v-icon>mdi-cube </v-icon>
                  {{ totals["bought"]["number"] }} Pieces
                  <br />
                  <v-icon>mdi-clock </v-icon>
                  {{ totals["bought"]["time"] }} Hours
                </v-card-text>
              </v-card>
              <!-- </v-col> -->
              <!-- <v-spacer /> -->
              <!-- <v-spacer /> -->
              <v-spacer />

              <!-- OUT TOTALS  -->
              <!-- <v-col class ="green"/> -->
              <!-- <v-col class ="yellow d-flex justify-center" > -->
              <v-card width="300" class="pa-1 dark">
                <v-card-title class="text-uppercase text-h5 justify-center">
                  Given
                </v-card-title>
                <v-card-text class="text-start text-h7">
                  <v-icon>mdi-cash-multiple </v-icon>
                  {{ totals["sold"]["price"].toFixed(2) }} L
                  <br />
                  <v-icon>mdi-weight </v-icon>
                  {{ totals["sold"]["weight"] }} Kg
                  <br />
                  <v-icon>mdi-cube </v-icon>
                  {{ totals["sold"]["number"] }} Pieces
                  <br />
                  <v-icon>mdi-clock </v-icon>
                  {{ totals["sold"]["time"] }} Hours
                </v-card-text>
              </v-card>
            </v-col>
            <v-spacer />
            <v-col cols="2" />
            <!-- <v-col class="" /> -->
          </v-row>
          <v-card class="mt-4 mx-auto pa-7" max-width="800" elevation="3">
            <v-card-title class="text-uppercase">
              Transaction Summaries
            </v-card-title>
            <v-select
              :items="chartDV"
              label="Select Your Data"
              item-text="label"
              item-value="val"
              outlined
              v-model="defaultSelected"
              @change="updateAllData(defaultSelected)"
            ></v-select>

            <div class="main-content">
              <div class="row">
                <div class="col-sm-12">
                  <div class="card">
                    <!--                     <div class="card-header">
                      <h6>Chartjs</h6>
                    </div> -->
                    <div class="card-body">
                      <div class="mb-4" id="given">
                        <h4 class="section-semi-title">
                          How much has each partner of In limbo given?
                        </h4>

                        <reactive-bar-chart
                          :chart-data="histDataGiven"
                          :options="histOptions"
                        ></reactive-bar-chart>
                      </div>
                      <div class="mb-4">
                        <h4 class="section-semi-title" id="taken">
                          How much has each partner of In limbo taken?
                        </h4>

                        <reactive-bar-chart
                          :chart-data="histDataTaken"
                          :options="histOptions"
                        ></reactive-bar-chart>
                      </div>
                      <div class="mb-4" id="all">
                        <h4 class="section-semi-title">
                          How much have you given and taken each year?
                        </h4>
                        <!-- <v-container> -->
                        <!-- <v-row> -->
                        <!-- <v-spacer /> -->
                        <!-- <v-cols cols="12"> -->
                        <reactive-bar-chart
                          :chart-data="chartData"
                          :options="barOptions"
                        ></reactive-bar-chart>
                        <!-- </v-cols> -->
                        <!-- <v-spacer /> -->
                        <!-- </v-row> -->
                        <!-- </v-container> -->
                      </div>
                      <div class="mb-4">
                        <!-- <h4 class="section-semi-title">Given by Category</h4> -->
                        <!-- <v-container> -->
                        <!-- <v-row> -->
                        <!-- <v-spacer /> -->
                        <!-- <v-cols cols="12"> -->
                        <h4 class="section-semi-title">
                          How much have you taken from each kind of object?
                        </h4>
                        <div style="padding-top: 20px">
                          <reactive-pie-chart
                            :width="300"
                            :height="300"
                            :chart-data="boughtPieDataset"
                            :options="pieOptions"
                          ></reactive-pie-chart>
                        </div>
                      </div>
                      <!-- </v-cols> -->
                      <!-- <v-spacer /> -->
                      <!-- </v-row> -->
                      <!-- <v-row> -->
                      <!-- <v-spacer /> -->
                      <!-- <v-spacer /> -->
                      <!-- <v-cols cols="12"> -->
                      <div>
                        <h4 class="section-semi-title">
                          How much have you given from each kind of object?
                        </h4>
                        <div style="padding-top: 20px">
                          <reactive-pie-chart
                            :width="300"
                            :height="300"
                            :chart-data="soldPieDataset"
                            :options="pieOptions"
                          ></reactive-pie-chart>
                        </div>
                      </div>
                      <!-- </v-cols> -->
                      <!-- <v-spacer /> -->
                      <!-- </v-row> -->
                      <!-- </v-container> -->
                      <!-- </div> -->

                      <!-- <bar-chart :chart-data="chartData"></bar-chart> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-container>
        <v-container class="pa-1">
          <v-row>
            <v-col />
            <v-col cols="2" />

            <!--             <v-card>
 -->
            <v-btn v-on:click="downloadCSVData()" class="ma-6" elevation="2">
              Download CSV
            </v-btn>
            <v-spacer> </v-spacer>
            <v-btn v-on:click="exportToPDF()" class="ma-6" elevation="2">
              Download PDF
            </v-btn>

            <!-- </v-card> -->
            <v-col cols="2" />
            <v-col />
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import ReactiveBarChart from "../components/ReactiveBarChart.vue";
import ReactivePieChart from "../components/ReactivePieChart.vue";
// import "chartjs-plugin-colorschemes";
// import html2pdf from "html2pdf.js";
// import html2canvas from "html2canvas";
import domtoimage from "dom-to-image-more";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import axios from "axios";
export default {
  props: {},
  components: {
    ReactiveBarChart,
    ReactivePieChart,
  },
  data() {
    return {
      values: undefined,
      colors: [
        "rgba(112, 214, 255, 0.8)",
        "rgba(255, 112, 166, 0.8)",
        "rgba(255, 151, 112, 0.8)",
        "rgba(255, 214, 112, 0.8)",
        "rgba(233, 255, 112, 0.8)",
        "rgba(243, 249, 210, 0.8)",
        "rgba(189, 196, 167, 0.8)",
        "rgba(58, 68, 84, 0.8)",
        "rgba(107, 78, 113, 0.8)",
      ],
      catTotals: {
        sold: { weight: {}, price: {}, number: {}, time: {} },
        bought: { weight: {}, price: {}, number: {}, time: {} },
      },
      barChartData: { labels: [], datasets: [] },
      soldPieDataset: null,
      boughtPieDataset: null,

      // valuesline: undefined,
      labels: undefined,
      loaded: false,
      items: [],
      yearTotals: [],
      datasets: null,
      totals: {
        sold: { weight: 0, price: 0, number: 0, time: 0 },
        bought: { weight: 0, price: 0, number: 0, time: 0 },
      },
      chartData: null,

      chartDV: [
        { val: "weight", label: "Weight" },
        { val: "number", label: "Number" },
        { val: "price", label: "Price" },
        { val: "time", label: "Time" },
      ],
      yAxisLabels: {
        weight: "Weight in Kg",
        number: "Number of Articles",
        price: "Price in Limbos",
        time: "Time in Hours",
      },
      defaultSelected: "weight",
      orgStats: {
        taken: {
          weight: [],
          time: [],
          number: [],
          price: [],
        },
        given: {
          weight: [],
          time: [],
          number: [],
          price: [],
        },
      },
      ranks: {
        taken: {
          weight: [],
          time: [],
          number: [],
          price: [],
        },
        given: {
          weight: [],
          time: [],
          number: [],
          price: [],
        },
      },
      uniqueOrgs: 0,
      histDataGiven: null,
      histDataTaken: null,
      orgListing: null,
      plotDataURLs: [],
      chartReady: false,
      selectedOrgID: 1,
    };
  },

  mounted() {
    // setInterval(this.generateData, 2000);
    this.plot2DataURL("given");
  },
  created: function () {
    this.userLang = this.getCookie("recup_lang");
    if (this.$route.query.id) {
      this.selectedOrgID = this.$route.query.id;
    }
    this.fetchOrgList();
    this.fetchBarChartData({ anio: 2018 });
    this.fetchOrgStats({ anio: 2018 });

    // this.createBarData(this.defaultSelected);
    // this.defaultSelected = "weight";
  },
  beforeMount: function () {},

  computed: {
    // datasets: null,
    // labels: undefined,
    barOptions: function () {
      var options = {
        responsive: true,
        cutoutPercentage: 50,
        layout: {
          margin: { top: 20 },
        },
        barValueSpacing: 20,

        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        scales: {
          // Shouldn't be an array.
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                suggestedMin: 0, // minimum will be 0, unless there is a lower value.
                // OR //

                // beginAtZero: true   // minimum value will be 0.
              },
              gridLines: {
                display: false,
              },
              position: "left",
              type: "linear",
              scaleLabel: {
                display: true,
                labelString: this.yAxisLabels[this.defaultSelected],
                beginAtZero: true,
              },
              //yAxisID: "id1"
              id: "id1", // incorrect property name.
            },
          ],
          //}]
        },
      };
      return options;
    },
    histOptions: function () {
      var options = {
        plugins: [
          {
            beforeInit: function (chart) {
              chart.data.labels.forEach(function (e, i, a) {
                if (/\n/.test(e)) {
                  a[i] = e.split(/\n/);
                }
              });
            },
          },
        ],
        responsive: true,
        layout: {
          margin: { top: 20 },
        },
        barValueSpacing: 0,

        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        scales: {
          // Shouldn't be an array.
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              barPercentage: 1.3,
              scaleLabel: {
                display: true,
                labelString: "All Partners in Limbo",
                beginAtZero: false,
              },
            },
          ],

          yAxes: [
            {
              display: true,
              ticks: {
                suggestedMin: 0, // minimum will be 0, unless there is a lower value.
                // OR //

                // beginAtZero: true   // minimum value will be 0.
              },
              gridLines: {
                display: false,
              },
              position: "left",
              type: "linear",
              scaleLabel: {
                display: true,
                labelString: this.yAxisLabels[this.defaultSelected],
                beginAtZero: false,
              },
              //yAxisID: "id1"
              id: "id1", // incorrect property name.
            },
          ],
          //}]
        },
      };
      return options;
    },
    pieOptions: function () {
      var options = {
        responsive: true,
        aspectRatio: 1,
        plugins: {},
        cutoutPercentage: 50,

        barValueSpacing: 20,

        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "bottom",
        },
        scales: {
          // Shouldn't be an array.
          xAxes: [
            {
              display: false,

              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                suggestedMin: 0, // minimum will be 0, unless there is a lower value.
                // OR //

                beginAtZero: true, // minimum value will be 0.
              },
              gridLines: {
                display: false,
              },
              position: "left",
              type: "linear",
              scaleLabel: {
                display: false,
                labelString: this.yAxisLabels[this.defaultSelected],
                beginAtZero: true,
              },
              //yAxisID: "id1"
              id: "id1", // incorrect property name.
            },
          ],
          //}]
        },
      };
      return options;
    },
  },

  methods: {
    plot2DataURL(imageID) {
      // small function that takes the relevant plots and converts em to URls
      var vm = this;
      // this.defaultSelected = "weight";

      var node = document.getElementById("given");
      domtoimage.toPng(node).then(function (dataUrl) {
        vm.plotDataURLs.push(dataUrl);
      });

      var node = document.getElementById("taken");
      domtoimage.toPng(node).then(function (dataUrl) {
        vm.plotDataURLs.push(dataUrl);
      });
      // vm.defaultSelected = "number";
      // // vm.updateAllData("number").then(function () {
      // var node = document.getElementById("given");
      // domtoimage.toPng(node).then(function (dataUrl) {
      //   vm.plotDataURLs.push(dataUrl);
      // });

      // var node = document.getElementById("taken");
      // domtoimage.toPng(node).then(function (dataUrl) {
      //   vm.plotDataURLs.push(dataUrl);
      // });
      // });
    },

    download() {
      // var scriptTagB = document.createElement("script");
      // scriptTagB.src =
      //   // "https://html2canvas.hertzen.com/dist/html2canvas.min.js";
      //   "https://cdnjs.cloudflare.com/ajax/libs/dom-to-image/2.6.0/dom-to-image.min.js";
      // document.getElementsByTagName("head")[0].appendChild(scriptTagB);

      // actual code
      var vm = this;
      // this.plot2DataURL("taken");

      var node = document.getElementById("given");
      // var options = {
      //   quality: 1,
      // };
      console.log(node);
      domtoimage
        .toPng(node)
        .then(function (dataUrl) {
          var img = new Image();
          console.log(dataUrl);
          img.src = dataUrl;
          // document.body.appendChild(img);
          var doc = new jsPDF();
          doc.setFontSize(35);
          doc.text("in limbo", 20, 20);
          doc.setFontSize(12);
          doc.text("www.inlimbobxl.org", 20, 30);
          doc.text("Avenue du port 53 – 1000 Bruxelles", 20, 35);
          doc.text("info@inlimbobxl.org - 0474 74 56 18", 20, 40);

          var comentWidth = doc.internal.pageSize.getWidth();
          // var biggerTxt
          doc.setFontSize(20);

          doc.text("Donator Info:", 20, 60);
          doc.setFontSize(14);
          doc.text("Name: La Monnaie", 25, 70);
          doc.text("Contact: info@lamonnaie.be", 25, 76);
          doc.line(20, 85, 200, 85);

          doc.setFontSize(20);

          doc.text("Overview of transactions", 20, 95);

          doc.setFontSize(18);
          var currYear = String(new Date().getFullYear());
          doc.text(currYear, 25, 110);
          doc.setFontSize(16);
          doc.text("Given", 60, 110);
          doc.line(60, 112, 76, 112);
          doc.setFontSize(12);

          doc.text(
            "Weight: " + vm.yearTotals[currYear]["weight"]["sold"] + " Kg ",
            60,
            120
          );
          doc.text(
            "Quantity: " +
              vm.yearTotals[currYear]["number"]["sold"] +
              "  Articles ",
            60,
            128
          );
          doc.setFontSize(16);

          doc.text("Taken", 120, 110);
          doc.line(120, 112, 137, 112);
          doc.setFontSize(12);

          doc.text(
            "Weight: " + vm.yearTotals[currYear]["weight"]["bought"] + " Kg ",
            120,
            120
          );
          doc.text(
            "Quantity: " +
              vm.yearTotals[currYear]["number"]["bought"] +
              "  Articles ",
            120,
            128
          );

          doc.setFontSize(18);
          doc.text("All Time", 25, 140);
          doc.setFontSize(16);
          doc.text("Given", 60, 140);
          doc.line(60, 142, 76, 142);
          doc.setFontSize(12);

          doc.text("Weight: " + vm.totals["sold"]["weight"] + " Kg ", 60, 150);
          doc.text(
            "Quantity: " + vm.totals["sold"]["number"] + "  Articles ",
            60,
            158
          );
          doc.setFontSize(16);

          doc.text("Taken", 120, 140);
          doc.line(120, 142, 137, 142);
          doc.setFontSize(12);

          doc.text(
            "Weight: " + vm.totals["bought"]["weight"] + " Kg ",
            120,
            150
          );
          doc.text(
            "Quantity: " + vm.totals["bought"]["number"] + "  Articles ",
            120,
            158
          );
          doc.setFontSize(18);

          doc.text(
            "In " +
              currYear +
              ", your articles have been given to: 45 partners ",
            20,
            185
          );
          doc.line(20, 195, 200, 195);

          doc.setFontSize(14);
          // doc.text("On the following pages you can find:", 20, 225);
          // doc.text("Page 2: All of your individual transactions", 30, 235);
          // doc.text("Page 3: All of your individual transactions", 30, 245);
          // doc.addPage();

          // ////////////////
          // page 2: graphs
          // ////////////////
          // doc.setFontSize(18);
          // doc.text("How much has each partner given to In Limbo? ", 20, 20);
          // doc.setFontSize(15);
          // doc.text("Weight (Pink = La Monnaie) ", 20, 28);

          // doc.addImage(dataUrl, "png", 40, 40, 120, 70);
          // doc.addImage(vm.plotDataURLs[0], "png", 40, 40, 120, 70);
          // doc.addImage(vm.plotDataURLs[1], "png", 40, 80, 120, 70);
          // doc.addImage(vm.plotDataURLs[2], "png", 40, 120, 120, 70);
          // doc.addImage(vm.plotDataURLs[3], "png", 40, 160, 120, 70);
          // doc.addPage();

          // ////////////////
          // page 3: table containing all transactions
          // ////////////////
          var columns = [
            "action",
            "category",
            "date_sold",
            "n_pieces_sold",
            "total_price",
            "total_weight",
            "total_hours",
          ];

          // read in data
          var output = vm.items.map(function (obj) {
            return Object.keys(obj)
              .sort()
              .map(function (key) {
                return obj[key];
              });
          });
          console.log(output);
          var data = [
            [1, "IT", 2, 1, 0],
            [2, "Comp", 1, 0, 0],
          ];
          data = output;
          console.log(data);
          doc.addPage();

          doc.autoTable(columns, data, { margin: { top: 60 } });

          doc.save("inlimbo_proof_of_donation.pdf");
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
      // domtoimage.toPng(node, options).then(function (dataUrl) {
      //   var doc = new jsPDF();
      //   doc.addImage(dataUrl, "JPEG", -18, 20, 240, 134.12);
      //   doc.save("Test.pdf");
      // });
      // let pdf = new jsPDF("l", "pt", "a4");
      // pdf.html(document.getElementById("all"), {
      //   callback: function () {
      //     pdf.save("test.pdf");
      //     // window.open(pdf.output("bloburl")); // to debug
      //   },
      // });
    },

    exportToPDF() {
      var self = this;
      self.download();
      console.log("passed");
      // console.log("genning pdf");
      // var elID = document.getElementById("all");
      // // console.log(elID);

      // const doc = new jsPDF();

      // doc.text("Hello world!", 10, 10);
      // html2canvas(elID, { scale: 20 })
      //   .then(function (canvas) {
      //     self.test = canvas.toDataURL().split(";base64,")[1];
      //     // var imgData = this.toDataUrl(canvas);
      //     console.log("bloop");
      //     document.body.appendChild(canvas);
      //   })
      //   .then(function () {
      //     doc.addImage(self.test, "png", 10, 78, 160, 90);

      //     doc.save("a4.pdf");
      //   });
    },
    generateData() {
      this.chartData = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()],
          },
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()],
          },
        ],
      };
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    async fetchOrgList() {
      var vm = this;
      console.log(vm.$store.state.pathDepth);
      this.$api
        .post(vm.$store.state.pathDepth + "orgListing_query.php", {})
        .then((response) => {
          vm.orgListing = response.data;
        });
    },
    async fetchOrgStats({ anio, sort }) {
      var self = this;
      fetch(this.$store.state.pathDepth + "orgStatQuery.php", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then(function (response) {
          var r = response.json();
          // self.uniqueOrgs = response[1];
          return r;
        })
        .then(function (arrayData) {
          // console.log(data);
          var data = arrayData[0];
          self.uniqueOrgs = arrayData[1];
          data.forEach((e) => {
            for (const [key, value] of Object.entries(
              self.orgStats[e.action]
            )) {
              self.orgStats[e.action][key].push(Math.round(e[key] * 1e2) / 1e2);
            }
            // Object.keys(self.orgStats[e.action]);
            // self.orgStats[e.action].push(e);
          });
          // sort the array from high to low
          for (const [key, value] of Object.entries(self.orgStats.given)) {
            self.orgStats.given[key].sort(function (a, b) {
              return b - a;
            });
            self.orgStats.taken[key].sort(function (a, b) {
              return b - a;
            });
          }
          // get ranking for this partner
          for (const [key, valaue] of Object.entries(self.orgStats.given)) {
            // for each value, find the position in the array of this partner
            self.ranks.given[key] = self.orgStats.given[key].indexOf(
              self.totals.sold[key]
            );
            self.ranks.taken[key] = self.orgStats.taken[key].indexOf(
              self.totals.bought[key]
            );
          }
        })
        .then(function () {
          self.createHistData(self.defaultSelected);
          self.createBarData(self.defaultSelected);
          self.createPieData(self.defaultSelected);
        });
    },
    async fetchBarChartData({ anio, sort }) {
      var self = this;
      var vm = this;
      this.totals = {
        sold: { weight: 0, price: 0, number: 0, time: 0 },
        bought: { weight: 0, price: 0, number: 0, time: 0 },
      };
      this.catTotals = {
        sold: { weight: {}, price: {}, number: {}, time: {} },
        bought: { weight: {}, price: {}, number: {}, time: {} },
      };
      this.ranks = {
        taken: {
          weight: [],
          time: [],
          number: [],
          price: [],
        },
        given: {
          weight: [],
          time: [],
          number: [],
          price: [],
        },
      };
      this.orgStats = {
        taken: {
          weight: [],
          time: [],
          number: [],
          price: [],
        },
        given: {
          weight: [],
          time: [],
          number: [],
          price: [],
        },
      };
      this.yearTotals = [];
      // console.log("in here");
      // console.log(vm.selectedOrgID);
      // console.log(vm.$store.state.pathDepth);
      this.$api
        .post(vm.$store.state.pathDepth + "stat_query.php", {
          ID: vm.selectedOrgID,
        })
        .then(function (response) {
          // var r = response.json();
          console.log("orgID");
          console.log(vm.selectedOrgID);

          return response.data;
        })
        .then(function (data) {
          // console.log(data);
          self.items = data;
          console.log("items");
          console.log(self.items);
          console.log(data);
          // console.log(self.items);
          self.items.forEach((e) => {
            // console.log(e);
            //  calculate base totals
            self.totals[e.action]["price"] +=
              Math.round(e.total_price * 1e2) / 1e2;

            self.totals[e.action]["weight"] +=
              Math.round(e.total_weight * 1e2) / 1e2;
            self.totals[e.action]["number"] +=
              Math.round(e.n_pieces_sold * 1e2) / 1e2;
            self.totals[e.action]["time"] +=
              Math.round(e.total_hours * 1e2) / 1e2;
            // quick fix for rounding error
            self.totals[e.action]["price"] =
              Math.round(self.totals[e.action]["price"] * 1e2) / 1e2;
            //  grab the year in whcih the sale was made
            let transYear = e.date_sold.substr(0, 4);
            // console.log(transYear);

            if (!(transYear in self.yearTotals)) {
              self.yearTotals[transYear] = {
                price: { sold: 0, bought: 0 },
                weight: { sold: 0, bought: 0 },
                number: { sold: 0, bought: 0 },
                time: { sold: 0, bought: 0 },
              };
            }
            self.yearTotals[transYear]["weight"][e.action] +=
              Math.round(e.total_weight * 1e2) / 1e2;
            self.yearTotals[transYear]["price"][e.action] +=
              Math.round(e.total_price * 1e2) / 1e2;
            self.yearTotals[transYear]["number"][e.action] +=
              Math.round(e.n_pieces_sold * 1e2) / 1e2;
            self.yearTotals[transYear]["time"][e.action] +=
              Math.round(e.total_hours * 1e2) / 1e2;
          });
          let test = { values: [2, 5, 6], labels: ["lol", "zez", "zzz"] };

          // return self.yearTotals
          return;
          // return test
        })
        .then(function () {
          // calculate the piechart totals

          self.items.forEach((e) => {
            // console.log(e);
            //  calculate base totals

            if (!self.catTotals[e.action]["price"][e.category]) {
              self.catTotals[e.action]["price"][e.category] =
                Math.round(e.total_price * 1e2) / 1e2;
            } else {
              self.catTotals[e.action]["price"][e.category] +=
                Math.round(e.total_price * 1e2) / 1e2;
            }
            if (!self.catTotals[e.action]["weight"][e.category]) {
              self.catTotals[e.action]["weight"][e.category] =
                Math.round(e.total_weight * 1e2) / 1e2;
            } else {
              self.catTotals[e.action]["weight"][e.category] +=
                Math.round(e.total_weight * 1e2) / 1e2;
            }
            if (!self.catTotals[e.action]["time"][e.category]) {
              self.catTotals[e.action]["time"][e.category] =
                Math.round(e.total_hours * 1e2) / 1e2;
            } else {
              self.catTotals[e.action]["time"][e.category] +=
                Math.round(e.total_hours * 1e2) / 1e2;
            }
            if (!self.catTotals[e.action]["number"][e.category]) {
              self.catTotals[e.action]["number"][e.category] =
                Math.round(e.n_pieces_sold * 1e2) / 1e2;
            } else {
              self.catTotals[e.action]["number"][e.category] +=
                Math.round(e.n_pieces_sold * 1e2) / 1e2;
            }
          });
        })
        // .then(function(data) {
        .then(function () {
          // based on selected val, get different data subsets
          let check = [["Year", "Taken", "Given"]];
          let labels = [];
          let soldVals = [];
          let boughtVals = [];

          let select = "weight";
          self.yearTotals.forEach(function (totals, year) {
            boughtVals.push(totals[select].bought);
            soldVals.push(totals[select].sold);
            labels.push(year);
          });

          self.datasets = [
            {
              label: "Blue",
              backgroundColor: "rgba(255, 99, 132, 0.8)",
              data: [3, 7, 4],
            },
            {
              label: "Red",
              backgroundColor: "rgba(54, 162, 235, 0.8)",
              data: [4, 3, 5],
            },
            {
              label: "Green",
              backgroundColor: "rgba(255, 206, 86, 0.8)",

              data: [7, 2, 6],
            },
          ];

          // self.labels = data.labels;

          self.labels = labels;

          self.loaded = true;
          self.updateAllData(self.defaultSelected);
          // self.createHistData(self.defaultSelected);

          // self.createBarData(self.defaultSelected);
          // self.createPieData(self.defaultSelected);
        });
    },
    updateAllData: function (selectedDV) {
      this.createBarData(selectedDV);
      this.createHistData(selectedDV);
      this.createPieData(selectedDV);
    },
    createBarData: function (selectedDV) {
      // takes in the totals & yeartotals
      // returns the dataset array needed by chartJS barplots
      let datasets = [
        {
          label: "Given",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: [],
        },
        {
          label: "Taken",
          backgroundColor: "rgba(54, 162, 235, 0.8)",
          data: [],
        },
      ];

      this.yearTotals.forEach(function (totals, year) {
        datasets[0].data.push(totals[selectedDV].sold);
        datasets[1].data.push(totals[selectedDV].bought);
      });

      this.datasets = datasets;
      this.chartData = { labels: this.labels, datasets: this.datasets };
    },
    createHistData: function (selectedDV) {
      // takes in the totals & yeartotals
      // returns the dataset array needed by chartJS barplots
      let datasetsGiven = [
        {
          label: "Given",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: [],
        },
      ];
      let datasetsTaken = [
        {
          label: "Taken",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: [],
        },
      ];
      // get the data for this DV for given
      // check which orgs aren't included in orgStats because they have 0
      var nZeroOrgs = this.uniqueOrgs - this.orgStats.given[selectedDV].length;
      datasetsGiven[0].data = this.orgStats.given[selectedDV].concat(
        Array(nZeroOrgs).fill(0)
      );
      datasetsGiven[0].backgroundColor = Array(
        datasetsGiven[0].data.length
      ).fill("rgba(119, 136, 153, 0.6)");
      var labelsGiven = ["Most"].concat(
        Array(datasetsGiven[0].data.length - 2).fill("")
      );

      labelsGiven = labelsGiven.concat("Least");
      // so we can see even the orgs that have 0 values
      datasetsGiven[0].minBarLength = 10;

      // color code and label the current org
      // console.log(this.ranks.taken[selectedDV]);
      labelsGiven[this.ranks.given[selectedDV]] = "You";
      datasetsGiven[0].backgroundColor[this.ranks.given[selectedDV]] =
        "rgba(255, 99, 132, 0.8)";
      console.log(datasetsGiven);
      // set the dataset for the plot
      this.histDataGiven = {
        labels: labelsGiven,
        datasets: datasetsGiven,
      };
      // same for taken
      var nZeroOrgs = this.uniqueOrgs - this.orgStats.taken[selectedDV].length;
      datasetsTaken[0].data = this.orgStats.taken[selectedDV].concat(
        Array(nZeroOrgs).fill(0)
      );
      datasetsTaken[0].backgroundColor = Array(
        datasetsTaken[0].data.length
      ).fill("rgba(119, 136, 153, 0.6)");
      var labelsTaken = ["Most"].concat(
        Array(datasetsTaken[0].data.length - 2).fill("")
      );

      labelsTaken = labelsTaken.concat("Least");
      // so we can see even the orgs that have 0 values
      datasetsTaken[0].minBarLength = 10;

      // color code and label the current org
      // console.log(this.ranks.taken[selectedDV]);
      labelsTaken[this.ranks.taken[selectedDV]] = "You";
      datasetsTaken[0].backgroundColor[this.ranks.taken[selectedDV]] =
        "rgba(54, 162, 235, 0.8)";
      console.log(datasetsTaken);
      // set the dataset for the plot
      this.histDataTaken = {
        labels: labelsTaken,
        datasets: datasetsTaken,
      };
    },
    createPieData: function (selectedDV) {
      this.soldPieDataset = {
        labels: [],
        datasets: [
          {
            label: "Articles Given",
            data: [],
            backgroundColor: this.colors,
          },
        ],
      };
      // console.log(this.catTotals.sold.weight);
      // grab all the keys
      for (const [key, value] of Object.entries(
        this.catTotals["sold"][selectedDV]
      )) {
        if (value > 0) {
          this.soldPieDataset.labels.push(key);
          this.soldPieDataset.datasets[0]["data"].push(value);
        }
        // console.log(`${key}: ${value}`);
      }

      this.boughtPieDataset = {
        labels: [],
        datasets: [
          {
            label: "Articles Given",
            data: [],
            backgroundColor: this.colors,
          },
        ],
      };
      for (const [key, value] of Object.entries(
        this.catTotals["bought"][selectedDV]
      )) {
        if (value > 0) {
          this.boughtPieDataset.labels.push(key);
          this.boughtPieDataset.datasets[0]["data"].push(value);
        }
        // console.log(`${key}: ${value}`);
      }
    },

    getCookie: function (name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },

    downloadCSVData: function () {
      // spot for headers
      let headers = [
        "action",
        "category",
        "date_sold",
        "n_pieces_sold",
        "total_price",
        "total_weight",
        "total_hours",
      ];
      let csv = headers.join(",");
      csv += "\n";
      // read in data
      this.items.forEach((row) => {
        // add each data point
        let currRow = [];
        headers.forEach((key) => {
          currRow.push(row[String(key)]);
        });
        // add end of line
        csv += currRow.join(",");
        csv += "\n";
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "inlimbo_my_statistics.csv";
      anchor.click();
    },
    downloadPdfReport: function () {
      var pdfAnchor = document.createElement("a");
      pdfAnchor.href = "../../example_report.pdf";
      pdfAnchor.download = "example_report.pdf";
      pdfAnchor.click();
    },
  },
};
</script>

<!-- https://help.zingsoft.com/en/articles/1972026-zingchart-getting-started-with-vue -->

<!-- https://github.com/devstark-com/vue-google-charts 
https://codesandbox.io/embed/z699l6oq4p?module=%2Fsrc%2FApp.vue
-->
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
